/* eslint-disable */
import HttpClient from "../../shared-module/utilities/http-client";

const { ProtectedHttpClient } = HttpClient;

const MedicalGroupApi = {
  public: {},
  private: {
    /**
     * To fetch all available facilities for a medical group
     */
    fetchAllMedicalGroups: () => ProtectedHttpClient.get(`/medical-groups`),
    createMedicalGroup: (payload) => ProtectedHttpClient.post(`/medical-group/create`, payload),
    editMedicalGroup: ({ payload, medicalGroupId }) => ProtectedHttpClient.put(`/medical-group/update/${medicalGroupId}`, payload),
    deleteMedicalGroup: (medicalGroupId) => ProtectedHttpClient.delete(`/medical-group/delete/${medicalGroupId}`),
  },
};
export default MedicalGroupApi;
